import { createAPIClient } from "@shopware/api-client";
import type { operations } from "#shopware";
import axios from "axios";
import Cookies from "js-cookie";

const runtimeConfig = useRuntimeConfig();

const shopwareEndpoint =
  runtimeConfig.public?.shopware?.endpoint ??
  runtimeConfig.public?.shopware?.shopwareEndpoint;
const shopwareAccessToken =
  runtimeConfig.public?.shopware?.accessToken ??
  runtimeConfig.public?.shopware?.shopwareAccessToken;

const apiClient = createAPIClient<operations>({
  accessToken: shopwareAccessToken,
  baseURL: shopwareEndpoint,
});

export default apiClient;

export async function performVisionAISearch(sSearch: any, rPage?: any, user?: any) {
  try {
    const date = new Date().getTime();
    const userId = user.value?.id;
    let sessionId = '';
    if(user) {
      sessionId = date+'_'+user.value?.id;
    } else {
      sessionId = date+'_guest';
    }

    const body = {
      "sSearch": sSearch,
      "user": userId,
      "rPage": rPage,
      "sessionId": sessionId
    }

    const url = shopwareEndpoint + `visionai/search`;

    const response = await axios.post(url, body, {
      headers: {
        'Sw-Access-Key': shopwareAccessToken,
        'Sw-Context-Token': Cookies.get('sw-context-token'),
        'Content-Type': 'application/json',
        'sw-include-seo-urls': 'true' // Include any necessary headers
      }
    });

    if (response && response.data) {
      return response.data;
    } else {
      throw new Error('Response or response data is undefined.');
    }
  } catch (error) {
    console.log('error:', error);
    return error;
  }
}

export async function getProductList(categoryId: any, body: any) {
  try {
    const url = shopwareEndpoint + `product-listing/${categoryId}`;

    const response = await axios.post(url, body, {
      headers: {
        'Sw-Access-Key': shopwareAccessToken,
        'Sw-Context-Token': Cookies.get('sw-context-token'),
        'Content-Type': 'application/json',
        'sw-include-seo-urls': 'true' // Include any necessary headers
      }
    });

    if (response && response.data) {
      return response.data;
    } else {
      throw new Error('Response or response data is undefined.');
    }
  } catch (error) {
    console.log('error:', error);
    return error;
  }
}

export async function getProductsById(body: any) {
  try {
    const url = shopwareEndpoint + `product`;

    const response = await axios.post(url, body, {
      headers: {
        'Sw-Access-Key': shopwareAccessToken,
        'Sw-Context-Token': Cookies.get('sw-context-token'),
        'Content-Type': 'application/json',
        'sw-include-seo-urls': 'true' // Include any necessary headers
      }
    });

    if (response && response.data) {
      return response.data;
    } else {
      throw new Error('Response or response data is undefined.');
    }
  } catch (error) {
    console.log('error:', error);
    return error;
  }
}

export async function getCmsElementsFromCategory(categoryId: any) {
  try {
    const url = shopwareEndpoint + `category/${categoryId}`;
    const body = {
      "associations": {
        "media": {},
        "cmsPage": {
          "associations": {
            "sections": {
              "associations": {
                "blocks": {
                  "associations": {
                    "slots": {
                      "associations": {
                        "block": {
                          "associations": {
                            "slots": {
                              "associations": {}
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    const response = await axios.post(url, body, {
      headers: {
        'Sw-Access-Key': shopwareAccessToken,
        'Sw-Context-Token': Cookies.get('sw-context-token'),
        'Content-Type': 'application/json',
        'sw-include-seo-urls': 'true' // Include any necessary headers
      }
    });

    if (response && response.data) {
      return response.data;
    } else {
      throw new Error('Response or response data is undefined.');
    }
  } catch (error) {
    console.log('error:', error);
    return error;
  }
}

export async function getCmsElementsFromCategoryWithChilds(categoryId: any) {
  try {
    const url = shopwareEndpoint + `category`;
    const body = {
      "associations": {
        "media": {},
        "children": {},
        "cmsPage": {
          "associations": {
            "sections": {
              "associations": {
                "blocks": {
                  "associations": {
                    "slots": {
                      "associations": {
                        "block": {
                          "associations": {
                            "slots": {
                              "associations": {}
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      },
      "filter": [
        {
          "type": "equals",
          "field": "id",
          "value": categoryId
        }
      ],
    }

    const response = await axios.post(url, body, {
      headers: {
        'Sw-Access-Key': shopwareAccessToken,
        'Sw-Context-Token': Cookies.get('sw-context-token'),
        'Content-Type': 'application/json',
        'sw-include-seo-urls': 'true' // Include any necessary headers
      }
    });

    if (response && response.data) {
      return response.data.elements;
    } else {
      throw new Error('Response or response data is undefined.');
    }
  } catch (error) {
    console.log('error:', error);
    return error;
  }
}

export async function getCategoriesById(categoryId: any, body: any) {
  try {
    const url = shopwareEndpoint + `category/${categoryId}`;

    const response = await axios.post(url, body, {
      headers: {
        'Sw-Access-Key': shopwareAccessToken,
        'Sw-Context-Token': Cookies.get('sw-context-token'),
        'Content-Type': 'application/json',
        'sw-include-seo-urls': 'true' // Include any necessary headers
      }
    });

    if (response && response.data) {
      return response.data;
    } else {
      throw new Error('Response or response data is undefined.');
    }
  } catch (error) {
    console.log('error:', error);
    return error;
  }
}
